import React, { useContext } from 'react';
import { StateContext } from '../../StateContainer';
import { IoTrashSharp as TrashIcon } from 'react-icons/io5';
import { FaWandMagicSparkles as MagicStickIcon } from 'react-icons/fa6';
import { FaStar as Star } from 'react-icons/fa6';
import { LuFileJson as JsonIcon } from 'react-icons/lu';
import { MarkerType } from '@xyflow/react';

const KnotsEditorHeader = () => {
  const {
    versioniAgenteConversazionale, // Nodes
    nodes,
    setNodes,
    onNodesChange,

    // Edges
    edges,
    setEdges,
    onEdgesChange,

    // Dettagli nodi
    dettagliNodi,
    setDettagliNodi,

    // Current conversational version
    currentConversationalVersion,
    setCurrentConversationalVersion,

    // Selected Node
    selectedNode,
    setSelectedNode,

    // Viewport
    viewport,
    setViewport,
  } = useContext(StateContext);

  const CambiaVersioneConversazionale = (id) => {
    setCurrentConversationalVersion(id);

    let selectedConversation =
      versioniAgenteConversazionale &&
      versioniAgenteConversazionale.find((versione) => versione.id == id);

    let conversazione = selectedConversation.conversationalJSON;

    if (conversazione !== null || conversazione !== '') {
      let editorValueArray = JSON.parse(conversazione);

      if (editorValueArray) {
        if (editorValueArray.viewport) {
          setViewport(editorValueArray.viewport);
        }
        const newNodes = Object.keys(editorValueArray)
          .filter(
            (key) => key !== 'fullfillment_variables' && key !== 'viewport'
          )
          .map((key) => {
            const nodeData = editorValueArray[key];
            return {
              id: nodeData.id ? nodeData.id.toString() : '',
              data: { label: nodeData.node_label, actions: [] },
              type: nodeData.type,
              position: nodeData.position,
            };
          });

        setNodes(newNodes);

        const listFullfillmentVariables =
          editorValueArray.fullfillment_variables || [];

        const fullfillmentVariables = listFullfillmentVariables.filter(
          (fv) =>
            fv.label === '' &&
            fv.nome_variabile === '' &&
            fv.istruzioni_estrazione === ''
        );

        const newDettagliNodi = Object.keys(editorValueArray).reduce(
          (acc, key) => {
            if (key !== 'fullfillment_variables' && key !== 'viewport') {
              const nodeData = editorValueArray[key];
              acc[key] = {
                node_label: nodeData.node_label,
                id: nodeData.id,
                type: nodeData.type,

                position: nodeData.position,
                intents: nodeData.intents || [],
                fullfillment:
                  fullfillmentVariables.filter(
                    (fv) => fv.nodeId === nodeData.id
                  ) || [],
              };
            }
            return acc;
          },
          {}
        );

        setDettagliNodi(JSON.parse(conversazione));

        const newEdges = [];
        Object.keys(newDettagliNodi).forEach((key) => {
          const node = newDettagliNodi[key];
          if (node.intents) {
            node.intents.forEach((intent) => {
              let target = intent.target.toString();
              let source = node.id.toString();
              newEdges.push({
                id: `${node.id}-${intent.target}`,
                source: source,
                target: target,
                animated: true,
                type: source === target ? 'selfconnecting' : 'custom_edge',
                markerEnd: {
                  type: MarkerType.Arrow,
                },
                data: {
                  trigger: intent.trigger,
                  output_intent: intent.output_intent,
                  forceIntent: intent.forceIntent,
                  type: 'action',
                  id: intent.id,
                  target: intent.target,
                  source: node.id,
                },
              });
            });
          }
        });

        setEdges(newEdges);
      }
    } else {
      const initialNode = {
        id: '1',
        type: 'start',
        data: { label: 'Nodo 1', actions: [] },
        position: { x: 0, y: 50 },
      };

      setNodes([initialNode]);
      setDettagliNodi({
        'nodo-1': {
          node_label: 'Nodo 1',
          type: 'start',
          id: 1,
          position: { x: 0, y: 50 },
        },
      });
    }
  };

  const handleAddNode = () => {
    const existingIds = Object.keys(dettagliNodi)
      .map((key) => parseInt(key.replace('nodo-', ''), 10))
      .filter((id) => !isNaN(id));

    // Trova l'ID massimo esistente, se non ci sono nodi parti da 0
    const maxId = existingIds.length > 0 ? Math.max(...existingIds) : 0;

    // Incrementa l'ID per il nuovo nodo
    const newNodeId = maxId + 1;
    const nodeKey = `nodo-${newNodeId}`;

    // Calcolare la posizione al centro del viewport corrente
    // Convertiamo dalle coordinate dello schermo alle coordinate del flow
    const centerX = -viewport.x + window.innerWidth / 2 / viewport.zoom;
    const centerY = -viewport.y + window.innerHeight / 2 / viewport.zoom;

    const newNode = {
      id: newNodeId.toString(),
      type: nodes.length === 0 ? 'start' : 'execution', // Se è il primo nodo, type = "start"
      data: { label: `Nodo ${newNodeId}`, actions: [] },
      position: { x: centerX, y: centerY },
    };

    setNodes((nds) => [...nds, newNode]);

    setDettagliNodi((prev) => {
      const updatedDetails = {
        ...prev,
        [nodeKey]: {
          type: nodes.length === 0 ? 'start' : 'execution',
          node_label: `Nodo ${newNodeId}`,
          id: newNodeId,
          position: { x: centerX, y: centerY },

          intents: [],
        },
      };

      if (selectedNode) {
        const sourceNodeId = selectedNode.id;
        const sourceNodeKey = `nodo-${sourceNodeId}`;

        if (!updatedDetails[sourceNodeKey].intents) {
          updatedDetails[sourceNodeKey].intents = [];
        }

        const intentExists = updatedDetails[sourceNodeKey].intents.some(
          (intent) => intent.target === newNodeId.toString()
        );

        if (!intentExists) {
          updatedDetails[sourceNodeKey].intents.push({
            trigger: '',
            output_intent: '',
            forceIntent: false,
            target: newNodeId.toString(),
            id: `${sourceNodeId}-${newNodeId}`,
            source: sourceNodeId,
            target: newNodeId.toString(),
            animated: true,
            type: sourceNodeId === newNodeId ? 'selfconnecting' : 'custom_edge',
          });
        }

        setEdges((eds) => [
          ...eds,
          {
            markerEnd: {
              type: MarkerType.ArrowClosed,
              width: 20,
              height: 20,
            },
            id: `${sourceNodeId}-${newNodeId}`,
            source: sourceNodeId.toString(),
            target: newNodeId.toString(),
            type: 'action',
            animated: true,
            type: sourceNodeId === newNodeId ? 'selfconnecting' : 'custom_edge',
          },
        ]);
      }

      return updatedDetails;
    });
  };

  return (
    <div className="d-flex align-items-center justify-content-between ">
      <div className="d-flex align-items-center justify-content-start gap-2">
        <select
          className="form-select"
          value={currentConversationalVersion}
          onChange={(e) => CambiaVersioneConversazionale(e.target.value)}
        >
          {Array.isArray(versioniAgenteConversazionale) &&
          versioniAgenteConversazionale.length > 0 ? (
            versioniAgenteConversazionale.map((version) => (
              <option key={version.id} value={version.id}>
                {version.name}
                {version.isLive ? ' ⭐' : ''}
              </option>
            ))
          ) : (
            <option disabled>Nessuna versione disponibile</option>
          )}
        </select>
        <button
          data-bs-toggle="modal"
          data-bs-target="#modalPubblicaConversazione"
          className="btn bg-blue-button text-white"
        >
          Salva
        </button>

        <button
          data-bs-toggle="modal"
          data-bs-target="#modalLiveVersion"
          className={` btn d-flex align-items-center p-0 border rounded ${
            versioniAgenteConversazionale &&
            versioniAgenteConversazionale.some(
              (v) => v.id === parseInt(currentConversationalVersion) && v.isLive
            )
              ? ' text-warning disabled'
              : ''
          }`}
        >
          <span className={`p-2`}>
            <Star />
          </span>
          <span className="bg-warning text-white px-3 py-2">Pubblica</span>
        </button>

        {/* Ai JSON GENERATION  */}
        <button
          data-bs-toggle="modal"
          data-bs-target="#ModalAiJsonGenerator"
          className="btn magic-stick-button text-dark py-2"
        >
          <MagicStickIcon />
        </button>
      </div>

      <div className="d-flex align-items-center justify-content-end gap-2">
        <button
          onClick={handleAddNode}
          className="btn bg-green-second text-white"
        >
          + Aggiungi Nodo
        </button>
        <button
          // onClick={handleAddNode}
          className="btn bg-green-second text-white"
          data-bs-toggle="modal"
          data-bs-target="#modalJsonEditor"
        >
          <JsonIcon />
        </button>
        <button
          data-bs-toggle="modal"
          data-bs-target="#ModalDeleteVersion"
          className="btn bg-danger text-white"
        >
          <TrashIcon />
        </button>
      </div>
    </div>
  );
};

export default KnotsEditorHeader;
